// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"system-blocked"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M18.5 22C20.9853 22 23 19.9853 23 17.5C23 15.0147 20.9853 13 18.5 13C16.0147 13 14 15.0147 14 17.5C14 19.9853 16.0147 22 18.5 22Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 9.5V3H2V17H10.5M4 21H10.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M20.9749 15.0251L16.0251 19.9749M21.682 20.682C19.9246 22.4393 17.0754 22.4393 15.318 20.682C13.5607 18.9246 13.5607 16.0754 15.318 14.318C17.0754 12.5607 19.9246 12.5607 21.682 14.318C23.4393 16.0754 23.4393 18.9246 21.682 20.682Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SystemBlockedIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'system-blocked',
    ref,
    icon: element,
  },
));

SystemBlockedIcon.displayName = 'SystemBlockedIcon';

export default SystemBlockedIcon;
